const tech = [
    'Python',
    'Django',
    'HTML5',
    'CSS',
    'JavaScript',
    'React',
    'Redux',
    'SQL',
    'Node.js',
    'MongoDB',
    'Test Driven Development',
    'AGILE',
    'Scrum',
    'RESTful APIs',
    'GitHub, GitLab, & Heroku',
    'Postman & ARC',
    'VS Code'
]

export default tech